import React from "react";
import { E } from "./Emoji";
import { trackInitiateCheckout, type CheckoutTracking } from "../utils/metaPixel";
type CTAButtonProps = {
  href: string;
  children: string;
  /** Si se pasa, registra InitiateCheckout en el Meta Pixel antes de ir al checkout */
  checkout?: CheckoutTracking;
};
export function CTAButton({
  href,
  children,
  checkout
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!checkout) return;
    trackInitiateCheckout(checkout);
    // Abrir en otra pestaña (ctrl/cmd/clic medio): el navegador sigue normal
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    // Pequeña espera para que el evento llegue a Meta antes de salir de la página
    e.preventDefault();
    window.setTimeout(() => {
      window.location.href = href;
    }, 300);
  };
  return <a href={href} onClick={handleClick} className="flex w-full items-center justify-center rounded-xl bg-bright px-5 py-4 text-center text-base font-black uppercase text-white shadow-[0_0_28px_rgba(77,148,255,0.45)] transition-[transform,background-color] duration-150 ease-out hover:bg-[#6aa6ff] active:scale-[0.97] focus:outline-none focus-visible:ring-4 focus-visible:ring-sky/50 md:text-lg" data-id="element-25" data-mp="3cnrkyid0hzk4">
      <E data-id="element-26" data-mp="1n8o3poj27opg">{children}</E>
    </a>;
}